// eslint-disable-next-line eslint/no-restricted-imports
import { ERROR_TRANSLATIONS } from 'feature-site-members/src/constants'
import type { PASSWORD_PROTECTED_PAGE_TRANSLATION_KEYS } from './types'

export const PASSWORD_PROTECTED_PAGE_TRANSLATIONS: {
	[key in PASSWORD_PROTECTED_PAGE_TRANSLATION_KEYS]: { namespace: string; key: string; default: string }
} = {
	...ERROR_TRANSLATIONS,
	enterPasswordTitle: {
		namespace: 'dialogMixinTranslations',
		key: 'dialogMixinTranslations_GUEST_LOGIN_TITLE',
		default: 'Guest Area',
	},
	enterPasswordSubTitle: {
		namespace: 'dialogMixinTranslations',
		key: 'dialogMixinTranslations_GUEST_LOGIN_SUBTITLE',
		default: 'Please enter the password below.',
	},
	enterPasswordSubmitButton: {
		namespace: 'dialogMixinTranslations',
		key: 'SMRegister_GO',
		default: 'Go',
	},
	enterPasswordPasswordPlaceholder: {
		namespace: 'dialogMixinTranslations',
		key: 'PasswordLogin_Password',
		default: 'Password',
	},
	enterPasswordGeneralError: {
		namespace: 'dialogMixinTranslations',
		key: 'SMForm_Error_General_Err',
		default: 'Something went wrong. Try again later.',
	},
	enterPasswordBlankPassword: {
		namespace: 'dialogMixinTranslations',
		key: 'SMForm_Error_Password_Blank',
		default: 'Make sure you enter a password.',
	},
	enterPasswordCloseDialog: {
		namespace: 'dialogMixinTranslations',
		key: 'dialogMixinTranslations_Close_Dialog',
		default: 'Close',
	},
}

export const PASSWORD_PROTECTED_SITE_TRANSLATIONS: {
	[key in PASSWORD_PROTECTED_PAGE_TRANSLATION_KEYS]: { namespace: string; key: string; default: string }
} = {
	...PASSWORD_PROTECTED_PAGE_TRANSLATIONS,
	enterPasswordTitle: {
		namespace: 'SITEPASSWORD',
		key: 'SITEPASSWORD_guest_login_title',
		default: 'Password Protected',
	},
	enterPasswordSubTitle: {
		namespace: 'SITEPASSWORD',
		key: 'SITEPASSWORD_guest_login_subtitle',
		default: 'You need a password to view this site.',
	},
	enterPasswordPasswordPlaceholder: {
		namespace: 'SITEPASSWORD',
		key: 'SITEPASSWORD_guest_login_password_placeholder',
		default: 'Enter password',
	},
	enterPasswordSubmitButton: {
		namespace: 'SITEPASSWORD',
		key: 'SITEPASSWORD_guest_login_CTA',
		default: 'Continue to Site',
	},
}
